<template>
  <div class="business_wrapper_style_qja_a_this">
    <basic-container>
      <div class="form_wrapper">
        <div class="form_header">
          <div class="form_header_name">
            <div
              :class="['nav_item', { nav_item_select: item.status == status }]"
              v-for="(item, index) in navList"
              :key="index"
              @click="switchNav(item.status)"
            >
              {{ item.lable }}
            </div>
          </div>
          <div class="form_header_remarks"></div>
        </div>
        <div class="form_content">
          <!-- 银行付款账号管理 -->
          <div class="meetingrecord_wrapper" v-if="status == 1">
            <BankAccount ref="BankAccount" />
          </div>
        </div>
      </div>
    </basic-container>
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="isOnly"
      :clear="false"
      @setPeople="setPeople"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BankAccount from "./components/bankAccount";
import SelectPerson from "@/components/SelectPersonnel/person";

export default {
  name: "business",
  data() {
    return {
      navList: [
        {
          lable: "银行付款账号管理",
          status: 1,
        },
      ],
      status: 1,
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      query: {
        date: ["", ""],
      },
      isOnly: true,
    };
  },

  components: {
    SelectPerson,
    BankAccount,
  },
  computed: {
    ...mapGetters(["userInfo", "permission"]),
  },
  created() {},

  methods: {
    //切换
    switchNav(status) {
      this.status = status;
    },
  },
};
</script>

<style lang="scss" scoped>
.form_wrapper {
  height: 100%;
  margin: 0;
  box-sizing: border-box;
  // border-width: 1px;
  // border-style: solid;
  // border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    // background-color: rgba(249, 249, 249, 1);
    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px rgba(233, 233, 233, 1) solid;

    .form_header_name {
      flex: 1;
      display: flex;
      height: 100%;
      font-weight: 700;
      font-size: 14px;
      color: #666666;

      .nav_item {
        display: flex;
        align-items: center;
        // margin-left: 22px;
        padding: 0 25px;
        cursor: pointer;
      }
      .nav_item_select {
        color: rgb(64, 158, 255);
        position: relative;
        &::after {
          position: absolute;
          content: "";
          bottom: -2px;
          left: 0;
          transform: translate(0, -50%);
          height: 2px;
          width: 100%;
          background-color: #409eff;
        }
      }
    }
    .form_header_remarks {
      color: #999999;
      font-size: 13px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 0;
    .file_wrapper {
      .file_left {
        width: 240px;
        min-height: 600px;
        background-color: rgba(249, 249, 249, 1);
        text-align: center;
        .add_file {
          margin: 35px auto;
        }
        .nav_item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 0 25px;
          cursor: pointer;
          height: 50px;
          font-weight: 400;
          font-size: 13px;
          color: #333;
        }
        .nav_item_select {
          color: rgb(64, 158, 255);
          position: relative;
          background-color: rgba(64, 158, 255, 0.0980392156862745);
          &::after {
            position: absolute;
            content: "";
            bottom: 0;
            right: 0;
            height: 100%;
            width: 4px;
            background-color: #409eff;
          }
        }
      }
    }
    .meetingrecord_wrapper {
      padding: 20px;
    }
  }
}

.btn_save {
  text-align: center;
}
.member_list_wrapper {
  display: flex;
  flex-wrap: wrap;
}
</style>

<style>
.el_tooltip {
  width: 200px;
}
</style>
